var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForeheadBackVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778,
    height: 1024,
    viewBox: "0 0 778 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M931 0.000101715L931 1024L111 1024L-0.00012207 512L111 5.13312e-05L931 0.000101715Z",
    fill: "url(#paint0_linear_417_23292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_417_23292",
    x1: 0,
    y1: 1024,
    x2: 1064.54,
    y2: 165.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeheadBackVector);
export default __webpack_public_path__ + "static/media/ForeheadBackVector.6c762305408189c090d9d0c1adf743f3.svg";
export { ForwardRef as ReactComponent };